import { render, staticRenderFns } from "./editproduct.vue?vue&type=template&id=593c13ca&scoped=true&"
import script from "./editproduct.vue?vue&type=script&lang=js&"
export * from "./editproduct.vue?vue&type=script&lang=js&"
import style0 from "./editproduct.vue?vue&type=style&index=0&id=593c13ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c13ca",
  null
  
)

export default component.exports